module.exports = __webpack_public_path__ + "static/assets/ae5ac90fdf0567d998696067b5e799a5.svg";